<template>
  <div class="white-container full-page-container common-table">
    <el-button size="small" type="primary" icon="el-icon-plus" style="position: absolute;top: -50px;right: 0;" @click="addActivity">新增</el-button>
    <el-form class="search-bar" :inline="true" size="small">
      <el-form-item label="页面状态">
        <el-select v-model="search.status" placeholder="请选择页面状态">
          <el-option label="全部" value="" />
          <el-option v-for="item in statusList" :key="item.id" :label="item.value" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item class="search-form-item">
        <el-input v-model="search.campaignTitle" placeholder="请输入你想搜索的文字" prefix-icon="el-icon-search" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="querySubmit">查询</el-button>
        <el-button @click="resetSearchCriteria">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="activity-preorder operation-bar">
      <el-button size="small" type="primary" @click="tableRelease('')">
        立即发布
      </el-button>
    </div>
    <div class="activity-table">
      <tableList ref="multipleTable" size="small" :deal-data="dealData" :table-query="search" :query-function="$Api.loyaltyCampaign.activityList" style="width: 100%" @selection-change="selectionItemChange">
        <el-table-column type="selection" width="55" fixed :selectable="(row) => row.status == 0" />
        <el-table-column prop="id" label="页面ID" width="200" />

        <el-table-column prop="campaignTitle" label="活动标题" width="320" />
        <el-table-column prop="campaignTime" label="活动时间" width="180px">
          <template v-slot="{row}">
            {{ formatTime(row.campaignTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="160">
          <template v-slot="{row}">
            <el-tag :type="contentStatus[row.status].color" size="mini">{{ contentStatus[row.status].value }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作">
          <template v-slot="{row}">
            <el-button v-if="row.status == 0" size="small" type="text" class="link-color" @click="tableEdit(row)">编辑</el-button>
            <el-button size="small" type="text" class="link-color" @click="tableCopy(row)">复制</el-button>
            <el-button size="small" type="text" class="link-color" @click="copyLink(row.id)">复制链接</el-button>
            <el-button size="small" type="text" class="link-color" @click="tableDelete(row)">删除</el-button>
            <el-button v-if="row.status == 0" size="small" type="text" class="link-color" @click="tableRelease(row.id)">发布</el-button>
            <el-button v-if="row.status == 1" size="small" type="text" class="link-color" @click="tableRemoveShelf(row)">下架</el-button>
            <el-button size="small" type="text" class="link-color" @click="tablePreview(row)">预览</el-button>
          </template>
        </el-table-column>
      </tableList>
      <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="submitSuccess" />
      <el-dialog v-if="previewDialogVisible" :visible.sync="previewDialogVisible" title="活动内容预览" custom-class="preview-wrapper">
        <div class="qr-wrap">
          <img :src="urlCode" class="qr-code" style="width: 300px; height: 300px" alt="">
          <p>微信扫描二维码预览页面</p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import tableList from '@/components/TableList';
import Dialog from '@/components/Dialog';
export default {
  components: { tableList, Dialog },
  data() {
    const statusList = [
      { id: 0, value: '草稿', color: 'warning' },
      { id: 1, value: '已发布', color: 'success' },
    ];
    const contentStatus = {
      0: { value: '草稿', color: 'warning' },
      1: { value: '已发布', color: 'success' },
    };
    return {
      urlCode: '',
      statusList,
      contentStatus,
      search: {
        status: '',
        campaignTitle: '',
      },
      selectionId: [],
      formDialogShow: false,
      currentID: -1,
      information: {},
      previewDialogVisible: false,
    };
  },
  mounted() {
  },
  methods: {
    formatTime(val) {
      // if (val) return moment(val).format('YYYY.MM.DD');
      return val || '-';
    },
    copyLink(id) {
      const input = document.createElement("input");
      input.value = '/pages-campaign/lp/index?id=' + id;
      document.body.appendChild(input);
      input.select();
      document.execCommand("Copy");
      document.body.removeChild(input);
      this.$message.success("复制成功");
    },
    addActivity() {
      this.$router.push({ path: '/AIOminiApp-config/activePageConfiguration/add' });
    },
    openDialog(row, { operation, icon, subTitle }) {
      this.formDialogShow = true;
      row && (this.currentID = row.id);
      this.information = { operation, icon, subTitle };
    },
    tableEdit(row) {
      this.openDialog(row, {
        operation: 'edit',
        icon: 'warn',
        subTitle: `是否确认编辑页面ID为“${row.id}”的数据项？`,
      });
    },
    tableCopy(row) {
      this.openDialog(row, {
        operation: 'copy',
        icon: 'success',
        subTitle: `复制成功！是否进入新增页面？`,
      });
    },
    tableDelete(row) {
      this.openDialog(row, {
        operation: 'delete',
        icon: 'warn',
        subTitle: '如已对外发布，请谨慎操作，确定删除此活动吗？',
      });
    },
    tablePreview(row) {
      this.$Api.loyaltyCampaign.previewActivity(row.id).then(res => {
        this.urlCode = res;
        this.previewDialogVisible = true;
      });
    },
    tableRemoveShelf(row) {
      this.$Api.loyaltyCampaign.offlineActivity(row.id).then(res => {
        this.$message.success('下架成功');
        this.querySubmit();
      });
    },
    tableRelease(id) {
      let ids = [];
      if (id) {
        ids = [id];
      } else {
        if (this.selectionId.length > 0) {
          ids = this.selectionId;
        } else {
          this.$message.warning('请选择要发布的内容');
          return;
        }
      }
      this.$Api.loyaltyCampaign.publishActivity({ ids }).then(() => {
        this.$message.success('发布成功');
        this.querySubmit();
      });
    },
    handleDelete() {
      this.$Api.loyaltyCampaign.deleteActivity(this.currentID).then(() => {
        this.formDialogShow = false;
        this.$message.success('删除成功');
        this.$refs['multipleTable'].getTableList();
      }).catch(error => {
        this.formDialogShow = true;
        this.information = {
          operation: 'error',
          icon: 'error',
          subTitle: `${error.errorMessage}`,
        };
      });
    },
    handleCopy() {
      this.$router.push({ path: '/AIOminiApp-config/activePageConfiguration/add', query: { copyid: this.currentID } });
    },
    handleEdit() {
      this.$router.push({ path: '/AIOminiApp-config/activePageConfiguration/edit', query: { id: this.currentID } });
    },
    submitSuccess(operation) {
      const fnObj = {
        delete: this.handleDelete,
        copy: this.handleCopy,
        edit: this.handleEdit,
      };
      fnObj[operation]();
    },
    querySubmit() {
      this.$refs['multipleTable'].searchAndReset();
    },
    resetSearchCriteria() {
      this.search = this.$options.data.call(this).search;
      this.$nextTick(() => {
        this.$refs['multipleTable'].searchAndReset();
      });
    },
    deleteActivity() {
      this.$Api.content.deleteMarketContent(this.currentID).then(() => {
        this.dialogVisible = false;
        this.$message.success('删除成功');
        this.querySubmit();
      });
    },
    selectionItemChange(selection) {
      console.log('selection', selection);
      this.selectionId = selection.reduce((init, item) => {
        init.push(item.id);
        return init;
      }, []);
      console.log('this.selectionId', this.selectionId);
    },
    dealData(data) {
      return data;
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.preview-wrapper {
    width: 538px;
    .el-dialog__header {
      height: 6.85vh !important;
      line-height: 6.85vh;
      padding: 0 2.87vh 0 2.78vh !important;
      background: #000000 !important;
      box-sizing: border-box !important;
      .el-dialog__title {
        font-family: "Noto Sans SC";
        font-style: normal;
        font-weight: 500;
        font-size: 1.48vh;
        color: #ffffff;
      }
      .el-dialog__headerbtn {
        top: 2.87vh;
        right: 2.87vh;
        font-size: 1.11vh;
        .el-dialog__close {
          color: #ffffff;
          &:hover {
            color: #dc0019;
          }
        }
      }
    }
    .el-dialog__body {
      height: 400px;
      padding: 30px;
      box-sizing: border-box;
      .qr-wrap {
        text-align: center;
        .qr-code {
          width: 300px;
          height: 300px;
          margin-bottom: 20px;
        }
        p {
          font-family: "Noto Sans SC";
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 23px;
          color: #494949;
        }
      }
    }
  }
</style>

